import React, { useEffect, useState } from 'react';
import * as Unicons from '@iconscout/react-unicons';
import AdminLayout from '../../components/layout/admin';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import { useQuery } from '@tanstack/react-query';
import { Stack, Box, SegmentedControl, Space } from '@mantine/core';
import { getUserMission } from '../../services/user-mission';
import LoaderVoucher from '../redeem-user/LoaderVoucher';
import FailedIllustration from '../../components/fragments/IllustrationState/FailedIllustration';
import { ERROR_STATE } from '../../constants/defaultValues/errorState';
import MissionActive from './MissionActive';
import MissionInactive from './MissionInactive';
import MissionFinished from './MissionFinished';

const RnbMission = () => {
  const [selectedStatus, setSelectedStatus] = useState('active');
  const [tabStatus, setTabStatus] = useState([]);

  const fetchedRnBMission = useQuery({
    queryKey: ['getUserMission'],
    queryFn: () =>
      getUserMission({
        search: '',
        page: 1,
        size: 10
      })
  });

  const {
    data: dataRnbMission,
    isLoading,
    isFetching,
    isError
  } = fetchedRnBMission;

  useEffect(() => {
    if (dataRnbMission?.data) {
      setTabStatus([
        {
          value: 'active',
          label: `Active (${dataRnbMission?.data?.dataActive.length})`
        },
        {
          value: 'waiting',
          label: `Non Active (${dataRnbMission?.data?.dataWait.length})`
        },
        {
          value: 'finished',
          label: `Finished (${dataRnbMission?.data?.dataFinished.length})`
        }
      ]);
    } else {
      setTabStatus([
        {
          value: 'active',
          label: 'Active (0)'
        },
        {
          value: 'waiting',
          label: 'Waiting (0)'
        },
        {
          value: 'finished',
          label: 'Finished (0)'
        }
      ]);
    }
  }, [dataRnbMission?.data]);

  return (
    <AdminLayout>
      <Breadcrumbs
        pageTitle="Reward and Gamification"
        itemList={[
          {
            title: 'Reward and Gamification',
            href: '#',
            icon: <Unicons.UilGift size={16} />
          },
          {
            title: 'Mission',
            href: 'rnb/mission'
          }
        ]}
      />

      {tabStatus.length > 0 && (
        <Stack gap={0} my={16}>
          <Box component="div">
            <SegmentedControl
              value={selectedStatus}
              onChange={(value) => setSelectedStatus(value)}
              data={tabStatus}
              radius={'lg'}
            />
          </Box>
        </Stack>
      )}

      {isLoading && <LoaderVoucher />}

      {isError && (
        <FailedIllustration
          title={ERROR_STATE.error[0]}
          description={ERROR_STATE.resolution[0]}
          w={200}
        />
      )}

      {!isLoading && !isError && dataRnbMission?.data && (
        <>
          <MissionActive
            data={dataRnbMission?.data?.dataActive || []}
            activeTab={selectedStatus}
          />
          <MissionInactive
            data={dataRnbMission?.data?.dataWait || []}
            activeTab={selectedStatus}
          />
          <MissionFinished
            data={dataRnbMission?.data?.dataFinished || []}
            activeTab={selectedStatus}
          />
          <Space h={32} />
        </>
      )}
    </AdminLayout>
  );
};

export default RnbMission;
